import { render, staticRenderFns } from "./Jumbotrons.vue?vue&type=template&id=07379e8a&"
import script from "./Jumbotrons.vue?vue&type=script&lang=js&"
export * from "./Jumbotrons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07379e8a')) {
      api.createRecord('07379e8a', component.options)
    } else {
      api.reload('07379e8a', component.options)
    }
    module.hot.accept("./Jumbotrons.vue?vue&type=template&id=07379e8a&", function () {
      api.rerender('07379e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Jumbotrons.vue"
export default component.exports